export default "__VITE_ASSET__SLOcGRZJ__"